module.exports = __webpack_public_path__ + "media/images/dashboardimages/announcement-47c251525cc13145c47c8eab4eb7a539.svg";